import clash400 from "@/assets/fonts/clash-grotesk-400.woff2.asset.json";
import clash500 from "@/assets/fonts/clash-grotesk-500.woff2.asset.json";
import clash600 from "@/assets/fonts/clash-grotesk-600.woff2.asset.json";
import clash700 from "@/assets/fonts/clash-grotesk-700.woff2.asset.json";

export const BRAND_FONTS = [
  { value: "Clash Grotesk", label: "Clash Grotesk", source: "local" },
  { value: "Archivo", label: "Archivo", source: "google" },
  { value: "Space Grotesk", label: "Space Grotesk", source: "google" },
  { value: "Manrope", label: "Manrope", source: "google" },
  { value: "DM Sans", label: "DM Sans", source: "google" },
  { value: "Montserrat", label: "Montserrat", source: "google" },
  { value: "Playfair Display", label: "Playfair Display", source: "google" },
] as const;

export const BRAND_FONT_WEIGHTS = [
  { value: "400", label: "Regular" },
  { value: "500", label: "Medium" },
  { value: "600", label: "Semi-bold" },
  { value: "700", label: "Bold" },
] as const;

const supportedFonts = new Set<string>(BRAND_FONTS.map((font) => font.value));
const googleFonts = new Set<string>(
  BRAND_FONTS.filter((font) => font.source === "google").map((font) => font.value),
);

export function getSupportedBrandFont(value?: string) {
  return value && supportedFonts.has(value) ? value : undefined;
}

export function isGoogleBrandFont(value: string) {
  return googleFonts.has(value);
}

export function getFontStack(value?: string) {
  const font = getSupportedBrandFont(value);
  return font ? `'${font}', sans-serif` : undefined;
}

export function getSupportedBrandFontWeight(value: unknown, fallback: "400" | "700") {
  const normalized = String(value ?? "");
  return BRAND_FONT_WEIGHTS.some((weight) => weight.value === normalized) ? normalized : fallback;
}

export function ensureClashGrotesk() {
  if (document.getElementById("brand-font-clash-grotesk")) return;

  const style = document.createElement("style");
  style.id = "brand-font-clash-grotesk";
  style.textContent = `
    @font-face { font-family: 'Clash Grotesk'; src: url('${clash400.url}') format('woff2'); font-style: normal; font-weight: 400; font-display: swap; }
    @font-face { font-family: 'Clash Grotesk'; src: url('${clash500.url}') format('woff2'); font-style: normal; font-weight: 500; font-display: swap; }
    @font-face { font-family: 'Clash Grotesk'; src: url('${clash600.url}') format('woff2'); font-style: normal; font-weight: 600; font-display: swap; }
    @font-face { font-family: 'Clash Grotesk'; src: url('${clash700.url}') format('woff2'); font-style: normal; font-weight: 700; font-display: swap; }
  `;
  document.head.appendChild(style);
}
